<template>

<div>
<card type="nav-tabs" class="text-center">
  <div slot="header" class="card-header-primary">
    Tổng số dư
  </div>
  <h2 class="card-title" style="color: #3ca472;"><b>{{ balance }}</b></h2>
  <p class="card-text"></p>
    <a href="#" class="btn" v-on:click="deposit()">Deposit</a>
    <a href="#" class="btn" v-on:click="withdraw()">Withdraw</a>

 
  <card type="nav-tabs" class="text-center" v-bind:class="{ hide_draw: hideActive }">
  <h5 class="card-title">Select network and deposit</h5>

  <card class="col-md-4 ml-auto mr-auto">
    <base-input  >
        <select class="form-control" id="exampleFormControlSelect1">
          <option>Vietcombank</option>
          <option>Techcombank</option>
        </select>
    </base-input>
    <base-input type="text">
      </base-input>
   </card>
  <img src="http://eslkidsgames.com/Flash/QR%20Code%20Maker/eslkidsgames.com.png"/>
  </card>
    
  <card type="nav-tabs" class="text-center" v-bind:class="{ hide_draw: hideActiveWithdraw }">
  <h5 class="card-title">Select network and withdraw</h5>

  <card class="col-md-4 ml-auto mr-auto">
    <base-input  >
        <select class="form-control" id="exampleFormControlSelect1">
          <option>Vietcombank</option>
          <option>Techcombank</option>
        </select>
    </base-input>
    <base-input type="text">
      </base-input>

    <a href="#" class="btn btn-info" v-on:click="">next</a>
   </card>
  </card>

</card>

    <card :title="table1.title" class="text-left">
        <div class="table-responsive">
            <base-table :data="table1.data"
                    :columns="table1.columns"
                    thead-classes="text-primary">
            </base-table>
        </div>
    </card>
</div>

</template>
<script>
import Api from '../api/api'
import { API } from '../utils/constants'
import { BaseTable, Modal } from "@/components";
const tableColumns = ["created", "transactionStatus", "transactionType", "amount", "note",];

export default {
  components: {
    BaseTable,
    Modal
  },
  data() {
    return {
      table1: {
        title: "Transaction history",
        columns: [...tableColumns],
        data: []
      },
      balance: 0,
      hideActive: true,
      hideActiveWithdraw: true,
    };
  },
    mounted () {
    Api.get(API.TRANSACTION).then(res => {
      var arr1 = [];
      res.data.forEach(element => {
          var date = new Date(element.createdAt);
          var dt = new Intl.DateTimeFormat(['ban', 'id']).format(date)
          var da = {
            "amount": new Intl.NumberFormat('vi-VN', { style: 'currency', currency: 'VND' }).format(element.amount),
            "transactionstatus":  element.transactionStatus,
            "transactiontype": element.transactionType,
            "note": element.note,
            "created": dt
          }
          arr1.push(da);
        });

      this.table1.data=arr1
    })

    Api.get(API.WALLET).then(res => {
      this.balance = new Intl.NumberFormat('vi-VN', { style: 'currency', currency: 'VND' }).format(res.data.balance);
    })

  },
  methods: {
    deposit(){
        this.hideActiveWithdraw = true;

        this.hideActive = !this.hideActive;
    },
    withdraw(){
        this.hideActive = true;
        this.hideActiveWithdraw = !this.hideActiveWithdraw;
    },
    
  },


}
</script>
<style>
.hide_draw{
    display: none;
}
</style>